<template>
  <!-- HTML 经过 DOMPurify 清理后再渲染，避免直接信任接口返回的 Markdown。 -->
  <div
    class="answer-markdown"
    :class="{ 'is-streaming': streaming }"
    :aria-busy="streaming"
    v-html="safeHtml"
  ></div>
</template>

<script setup lang="ts">
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  content: string;
  streaming?: boolean;
}>(), {
  streaming: false,
});

// 输出期间会随 content 变化持续解析；关闭异步模式可确保 computed 始终返回字符串。
const safeHtml = computed(() => DOMPurify.sanitize(
  marked.parse(props.content, { async: false }) as string,
));
</script>

<style scoped lang="scss">
.answer-markdown {
  overflow-wrap: anywhere;

  :deep(> :first-child) { margin-top: 0; }
  :deep(> :last-child) { margin-bottom: 0; }

  :deep(p) { margin: 0 0 12px; }

  :deep(ul),
  :deep(ol) {
    margin: 16px 0;
    padding-left: 22px;
  }

  :deep(li) { margin-bottom: 10px; }

  :deep(a) {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  :deep(pre) {
    padding: 14px;
    border-radius: 8px;
    background: #f5f5f5;
    overflow-x: auto;
  }

  :deep(code) {
    font-family: Consolas, Monaco, monospace;
  }

  // &.is-streaming::after {
  //   display: inline-block;
  //   width: 2px;
  //   height: 1em;
  //   margin-left: 3px;
  //   background: currentColor;
  //   vertical-align: -.12em;
  //   animation: answer-caret .8s steps(1) infinite;
  //   content: '';
  // }
}

// @keyframes answer-caret {
//   50% { opacity: 0; }
// }

// @media (prefers-reduced-motion: reduce) {
//   .answer-markdown.is-streaming::after { animation: none; }
// }
</style>
